import { createConfirmation } from "react-confirm";
import InformDialog from "./InformDialog";

export const showInformDialog = createConfirmation(InformDialog);
